// Written by the merchant-portal host, which shares this origin: the email
// travels through storage because a URL is tracked and kept in history.
export const LOGIN_PREFILL_EMAIL_KEY = '@twism:login-prefill-email';

type TPrefillStorage = Pick<Storage, 'getItem' | 'removeItem'>;

const getSessionStorage = (): TPrefillStorage | undefined => {
  try {
    return window.sessionStorage;
  } catch {
    return undefined;
  }
};

export const takeLoginPrefillEmail = (
  storage: TPrefillStorage | undefined = getSessionStorage()
): string | undefined => {
  if (!storage) return undefined;

  let email: string | undefined;
  try {
    const stored = storage.getItem(LOGIN_PREFILL_EMAIL_KEY);
    email = (stored && stored.trim()) || undefined;
  } catch {
    email = undefined;
  }

  try {
    storage.removeItem(LOGIN_PREFILL_EMAIL_KEY);
  } catch {
    // A key that cannot be removed is still never read twice by this page.
  }

  return email;
};
